//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Pipe, PipeTransform } from '@angular/core';
import {IKey} from '../../../types/key';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'keyStatusText',
    standalone: false
})
export class KeyStatusTextPipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {}

  transform(key: IKey): string {
    if (key.hasProtectedKey && key.hasPublicKey) {
      return this.translate.instant('PUBLIC_PROTECTED_PRIVATE_KEY');
    } else if (key.hasPrivateKey && key.hasPublicKey) {
      return this.translate.instant('PUBLIC_PRIVATE_KEY');
    } else {
      return this.translate.instant('PUBLIC_KEY');
    }
  }

}
